import { getPublicWebsiteUrl } from 'app/js/configuration/environmentConfig'

const getLogoUrl = (t) => t('Common.companyLogo', { publicWebsiteUrl: getPublicWebsiteUrl() })
const getLandingPageUrl = (t) => t('Common.landingPageUrl', { publicWebsiteUrl: getPublicWebsiteUrl() })
const getPrivacyPolicyUrl = (t) => t('Common.privacyUrl', { publicWebsiteUrl: getPublicWebsiteUrl() })

export {
  getLogoUrl,
  getLandingPageUrl,
  getPrivacyPolicyUrl
}